export default __webpack_public_path__ + "static/z3-cd623628b466bd8ce80a148197e7424f.svg";